import getConfig from 'next/config';

const {
  publicRuntimeConfig: {
    GF_DOTCOM_ECOMM_CORE_ENDPOINT,
  },
} = getConfig();

const endpoint = GF_DOTCOM_ECOMM_CORE_ENDPOINT || '';

const getNavbarConfig = (featureFlags = {}) => ({
  routes: [
    {
      text: 'Home',
      url: '/',
      local: true,
      logoLink: true,
    },
    {
      text: 'Products',
      url: '/our-products',
      local: true,
    },
    {
      text: 'Reviews',
      url: '/reviews',
      local: true,
      disabled: featureFlags['reviews-nav-disabled'],
    },
    {
      text: 'Stories',
      url: '/v/stories',
      local: true,
      disabled: !featureFlags['stories-nav-enabled'],
    }, {
      text: 'Education',
      url: 'https://education.glowforge.com/',
    },
    {
      text: 'FAQ',
      url: '/faq',
      local: true,
    },
    {
      text: 'Community',
      url: 'https://community.glowforge.com',
    },
    {
      text: 'Gallery',
      url: '/discover',
    },
  ],
  userRoutes: {
    referrals: {
      local: false,
      text: 'Referrals',
      url: '/referrals',
      type: 'signed-in',
    },
    login: {
      local: false,
      text: 'Sign In',
      url: `${endpoint}/login`,
    },
    settings: {
      local: false,
      text: 'Settings',
      url: '/settings',
      type: 'signed-in',
    },
    logout: {
      local: false,
      text: 'Sign Out',
      url: `${endpoint}/logout`,
      type: 'signed-in',
    },
  },
  userSecondaryLinks: [{
    local: false,
    text: 'Referrals',
    url: '/referrals',
  }],
});

export default getNavbarConfig;
